import Preloader from '@/components/atoms/Preloader';
import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import AccordianIllustrationCard from './AccordianIllustrationCard';
import ProductSkeleton from './Skeleton/ProductSkeleton';
import React from 'react';

export default function AccordianCategoryShapes({ item }: any) {
    const [products, setProducts] = useState<any[]>([]);

    useEffect(() => {
       
        const data = item.node.products;
        if (data && data.length > 0) {
            const orderedProducts = [...data].sort(
                (a, b) => a.node.menuOrder - b.node.menuOrder,
            );
            
            setProducts(orderedProducts);
        }
    }, [item]);

    return (
        <Box sx={{ width: '100%' }}>
            <Grid container columns={12}>
                {products.length == 0 && <ProductSkeleton />}
                {products && products.length > 0 ? (
                    products.map((product, i) => (
                        <Grid
                            key={i}
                            item
                            xs={6}
                            sm={4}
                            md={3}
                            padding={1}
                        >
                          <AccordianIllustrationCard
                                item={product}
                                division_info={item.node.divisionInfo}
                            /> 
                        </Grid>
                    ))
                ) : (
                    <Grid item xs={12}>
                        <Preloader />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
}
